import { render } from "./PromptTable.vue?vue&type=template&id=341027e0&scoped=true"
import script from "./PromptTable.vue?vue&type=script&lang=js"
export * from "./PromptTable.vue?vue&type=script&lang=js"

import "./PromptTable.vue?vue&type=style&index=0&id=341027e0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-341027e0"]])

export default __exports__